import { useSiteTranslation } from "../i18n";
import "../styles/principles.css";

export function PrinciplesSection() {
  const { t } = useSiteTranslation();
  const principles = t("home.principles.items", { returnObjects: true });

  return (
    <section className="principles" aria-label={t("home.principles.label")}>
      <div className="wrap principles-grid">
        {principles.map(({ title, text }, index) => (
          <div key={title}>
            <span>{String(index + 1).padStart(2, "0")}</span>
            <p>
              <b>{title}</b>
              {text}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
